import { BrowserRouter } from 'react-router-dom';
import AppRoutes from '@app/router/AppRoutes';
import '@fontsource/dm-sans/latin-400.css';
import '@fontsource/dm-sans/latin-500.css';
import '@fontsource/dm-sans/latin-600.css';
import '@fontsource/dm-sans/latin-700.css';
import '@fontsource/dm-sans/latin-800.css';
import '@fontsource/dm-mono/latin-400.css';
import '@fontsource/dm-mono/latin-500.css';
import '@styles/global.css';
import '@styles/theme.css';
import '@styles/app-shell.css';
import '@styles/auth.css';
import '@styles/org-console.css';
import '@styles/brand.css';

const App = () => {
  return (
    <BrowserRouter>
      <AppRoutes />
    </BrowserRouter>
  );
};

export default App;
